// services/invoiceService.ts
import { authAxios } from './axiosInstance';

export const invoiceService = {
    /**
     * Create a new invoice
     */
    async createInvoice(invoiceData: any) {
        try {
            const response = await authAxios.post('/quotes/invoices', invoiceData);
            return response.data;
        } catch (error) {
            console.error('Error creating invoice:', error);
            throw error;
        }
    },

    /**
     * Get invoice details by ID
     */
    async getInvoiceDetails(invoiceId: string) {
        try {
            const response = await authAxios.get(`/quotes/invoices/${invoiceId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching invoice details:', error);
            throw error;
        }
    },

    /**
     * Get all invoices for a garage
     */
    async getInvoicesByGarage(garageId: string) {
        try {
            const response = await authAxios.get(`/quotes/invoices/garage/${garageId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching garage invoices:', error);
            throw error;
        }
    },

    /**
     * Update invoice status
     */
    async updateInvoiceStatus(invoiceId: string, newStatus: string) {
        try {
            const response = await authAxios.put(`/quotes/invoices/${invoiceId}/status`, {
                status: newStatus
            });
            return response.data;
        } catch (error) {
            console.error('Error updating invoice status:', error);
            throw error;
        }
    },

    /**
     * Download invoice PDF
     */
    async downloadInvoicePDF(invoiceId: string) {
        try {
            const response = await authAxios.get(`/quotes/invoices/${invoiceId}/download`, {
                responseType: 'blob'
            });

            // Create blob URL
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            // Extract filename from Content-Disposition header
            let filename = `invoice_${invoiceId}.pdf`;
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition && contentDisposition.includes('filename=')) {
                const filenameMatch = contentDisposition.match(/filename=["']?([^"']+)["']?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }

            // Trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Cleanup
            URL.revokeObjectURL(url);
            document.body.removeChild(link);

            return true;
        } catch (error) {
            console.error('Error downloading invoice PDF:', error);
            return false;
        }
    }
};